(() => {
  if (window.CarouselUXSizeLabels) return;
  window.CarouselUXSizeLabels = true;

  const sizeValuePattern = /^(\d+(?:[-/]\d+)?(?:\s*\([^)]*\))?)(?:\s+(.+))?$/;

  const updateSelectedValue = fieldset => {
    const selectedInput = fieldset.querySelector('.product-option__input:checked');
    const selectedValue = fieldset.querySelector('[data-selected-value]');
    const selectedLabel = selectedInput?.nextElementSibling;

    if (selectedValue && selectedLabel?.dataset.carouselCompactLabel) {
      selectedValue.textContent = selectedLabel.dataset.carouselCompactLabel;
    }
  };

  const compactFieldset = fieldset => {
    if (fieldset.dataset.carouselSizeLabelsReady === 'true') return;

    const choices = [...fieldset.querySelectorAll('.product-option__input')]
      .map(input => ({
        input,
        label: input.nextElementSibling?.matches('.product-option__label')
          ? input.nextElementSibling
          : null,
        fullValue: input.value.trim(),
      }))
      .filter(choice => choice.label);

    if (choices.length < 2) return;

    const parsedValues = choices.map(choice => choice.fullValue.match(sizeValuePattern));
    if (parsedValues.some(match => !match)) return;

    const compactLabels = parsedValues.map(match => match[1].trim());
    const suffixes = parsedValues.map(match => (match[2] || '').trim());
    const sharedSuffix = suffixes[0];

    if (!sharedSuffix || !suffixes.every(suffix => suffix === sharedSuffix)) return;
    if (new Set(compactLabels).size !== compactLabels.length) return;

    choices.forEach((choice, index) => {
      const unavailable = choice.label.querySelector('.label-unavailable');
      const visibleLabel = document.createElement('span');
      const accessibleLabel = document.createElement('span');

      visibleLabel.setAttribute('aria-hidden', 'true');
      visibleLabel.textContent = compactLabels[index];
      accessibleLabel.className = 'visually-hidden';
      accessibleLabel.textContent = choice.fullValue;

      choice.label.replaceChildren(visibleLabel, accessibleLabel);
      if (unavailable) choice.label.append(unavailable);

      choice.label.title = choice.fullValue;
      choice.label.dataset.carouselCompactLabel = compactLabels[index];
    });

    fieldset.dataset.carouselSizeLabelsReady = 'true';
    updateSelectedValue(fieldset);
  };

  const scan = root => {
    if (root.matches?.('.product-form__input--size')) compactFieldset(root);
    root.querySelectorAll?.('.product-form__input--size').forEach(compactFieldset);
  };

  document.addEventListener('change', event => {
    const fieldset = event.target.closest?.('.product-form__input--size');
    if (fieldset) queueMicrotask(() => updateSelectedValue(fieldset));
  });

  scan(document);

  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
